import { Component } from '@angular/core';
import { PageWithTabsComponent } from '@docpath/linces-angular-components/common';
import { DpTab } from '@docpath/webcomponents';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { RoutingPath } from 'src/app/constants/routing-path';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  standalone: true,
  imports: [PageWithTabsComponent]
})
export class ConfigurationComponent {

  icon = faCog;
  tabs: DpTab[] = [
    new DpTab('configuration.tab.general', false, `/${RoutingPath.PATH_CONFIGURATION}/${RoutingPath.PATH_GENERAL}`),
    new DpTab('configuration.tab.services', false, `/${RoutingPath.PATH_CONFIGURATION}/${RoutingPath.PATH_SERVICES}`),
    new DpTab('configuration.tab.alert-rules', false, `/${RoutingPath.PATH_CONFIGURATION}/${RoutingPath.PATH_ALERT_RULES}`),
    new DpTab('configuration.tab.failed-jobs', false, `/${RoutingPath.PATH_CONFIGURATION}/${RoutingPath.PATH_FAILED_JOBS}`),
    new DpTab('configuration.tab.alias', false, `/${RoutingPath.PATH_CONFIGURATION}/${RoutingPath.PATH_ALIAS}`),
    new DpTab('configuration.tab.engines', false, `/${RoutingPath.PATH_CONFIGURATION}/${RoutingPath.PATH_ENGINES}`),
    new DpTab('configuration.tab.self-maintenance', false, `/${RoutingPath.PATH_CONFIGURATION}/${RoutingPath.PATH_SELF_MAINTENANCE}`)
  ];

}
